import { useState, useEffect } from 'react';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import CreateGroup from './CreateGroup';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import { userLimits } from '../uitls/userLimits';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import { Box, Typography, Chip, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import GroupsIcon from '@mui/icons-material/Groups';
import AddIcon from '@mui/icons-material/Add';
import ComputerIcon from '@mui/icons-material/Computer';
import PeopleIcon from '@mui/icons-material/People';

const getMyGroupsURL = `/groups/`;

export default function Groups(props) {
  const theme = useTheme();
  const { id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Groups',
    'edit_group'
  );

  const [update, setUpdate] = useState('false');
  const [show, setShow] = useState(false);
  const [checkedvalues, setcheckedvalues] = useState([]);
  const [checkedvalues2, setcheckedvalues2] = useState([]);
  const [reflesh, setreflesh] = useState(false);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [name, setname] = useState('');
  const [groupid, setGroupID] = useState('');
  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_group') ? localStorage.getItem('table_view_group') : 10
  );

  useEffect(() => {
    localStorage.setItem('table_view_group', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;
    // getMyMachines

    async function getMyGroups() {
      await request({
        method: 'get',
        url:
          props.match.params.group && superAdmin
            ? getMyGroupsURL + props.match.params.id
            : getMyGroupsURL + id,
      }).then((res) => {
        if (!isCancelled) {
          setGroups(res.data);
          setLoading(true);
        }
      });
    }
    getMyGroups();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deleteGroup = async (id) => {
    await request({
      method: 'delete',
      url: getMyGroupsURL + id,
    }).then();
    reflesh ? setreflesh(false) : setreflesh(true);
  };

  const columns = [
    {
      title: 'Group Name',
      field: 'name',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
          {rowData.name}
        </Typography>
      ),
    },
    {
      title: 'Machines',
      field: 'machines',
      render: (rowData) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxWidth: 400 }}>
          {rowData.machineID.length > 0 ? (
            rowData.machineID.map((e) => (
              <Chip
                key={e._id}
                icon={<ComputerIcon sx={{ fontSize: 14 }} />}
                label={`${e.name}`}
                size="small"
                sx={{
                  fontWeight: 500,
                  fontSize: '0.75rem',
                  backgroundColor: alpha(theme.palette.info.main, 0.1),
                  color: theme.palette.info.dark,
                  border: `1px solid ${alpha(theme.palette.info.main, 0.25)}`,
                  '& .MuiChip-icon': {
                    color: theme.palette.info.dark,
                  },
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.info.main, 0.15),
                  },
                }}
                title={e.description}
              />
            ))
          ) : (
            <Typography variant="caption" color="text.secondary">No machines</Typography>
          )}
        </Box>
      ),
    },
    {
      title: 'Users',
      field: 'users',
      render: (rowData) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxWidth: 400 }}>
          {rowData.userID.length > 0 ? (
            rowData.userID.map((e) => (
              <Chip
                key={e.email}
                icon={<PeopleIcon sx={{ fontSize: 14 }} />}
                label={`${e.firstname} ${e.lastname}`}
                size="small"
                sx={{
                  fontWeight: 500,
                  fontSize: '0.75rem',
                  backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                  color: theme.palette.secondary.dark,
                  border: `1px solid ${alpha(theme.palette.secondary.main, 0.25)}`,
                  '& .MuiChip-icon': {
                    color: theme.palette.secondary.dark,
                  },
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.secondary.main, 0.15),
                  },
                }}
                title={e.email}
              />
            ))
          ) : (
            <Typography variant="caption" color="text.secondary">No users</Typography>
          )}
        </Box>
      ),
    },
  ];
  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}
      <ModernPageHeader
        title={tableTitle || 'Groups'}
        subtitle="Manage your machine and user groups"
        icon={GroupsIcon}
        buttonText={access ? "Create Group" : undefined}
        buttonIcon={AddIcon}
        onButtonClick={access ? () => {
          setUpdate('false');
          setcheckedvalues([]);
          setcheckedvalues2([]);
          setname('');
          setShow(true);
          reflesh ? setreflesh(false) : setreflesh(true);
        } : undefined}
      />
      <Box sx={{ mt: 3 }}>
        <ModernTable
        columns={columns}
        data={groups}
        onRowsPerPageChange={setPagination}
        actions={[
          () =>
            access && {
              icon: 'edit',
              tooltip: 'Edit Group',
              onClick: (event, rowData) => {
                setUpdate('true');
                setcheckedvalues(rowData.machineID.map((e) => e._id));
                setcheckedvalues2(rowData.userID.map((e) => e._id));
                setname(rowData.name);
                setGroupID(rowData._id);
                setShow(true);
                reflesh ? setreflesh(false) : setreflesh(true);
              },
            },
        ]}
        editable={
          access && {
            onRowDelete: (oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  deleteGroup(oldData._id);
                  Swal.fire({
                    text: `A group has been successfully deleted: ${oldData.name}`,
                    icon: 'success',
                  });
                  resolve();
                }, 1000);
              }),
          }
        }
        options={{
          actionsColumnIndex: -1,
          pageSize: parseInt(pagination),
          pageSizeOptions: [10, 20, 50, 100],
        }}
        />
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
        <CreateGroup
          id={id}
          reflesh={+reflesh}
          checkedvalues={checkedvalues}
          setcheckedvalues={setcheckedvalues}
          checkedvalues2={checkedvalues2}
          setcheckedvalues2={setcheckedvalues2}
          setreflesh={setreflesh}
          name={name}
          setname={setname}
          groupid={groupid}
          update={update}
          show={show}
          onHide={() => setShow(false)}
        />
      </Box>
    </ModernPageContainer>
  );
}
